module.exports = __webpack_public_path__ + "img/starlight-social-logo.49cf922.png";